export const COLORS_CONSTANTS = {
    TEXT_COLOR_WHITE: "#FFFFFF",
    TEXT_COLOR_BLACK: "#000000",

    /* Figma Rapchik Revamped — global pastel glass theme */
    PAGE_BACKGROUND: "linear-gradient(90deg, #FBA3F9 0%, #C8B6FC 48%, #BCC9FF 100%)",
    PAGE_BACKGROUND_COLOR: "#E8D9FF",
    PAGE_BACKGROUND_IMAGE_KEY: "V2_REVAMPED_PAGE_BG",
    PAGE_TEXT: "#003",
    PAGE_TEXT_SECONDARY: "rgba(0, 0, 51, 0.72)",

    GLASS_SURFACE: "linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.5) 100%)",
    GLASS_SURFACE_SOLID: "rgba(255, 255, 255, 0.45)",
    GLASS_BORDER: "#FFFFFF",
    GLASS_SHADOW: "0px 4px 22px 0px rgba(255, 255, 255, 0.7)",
    GLASS_BLUR: "25px",

    BUTTON_SURFACE: "#E3CEFF",
    BUTTON_SURFACE_ACTIVE: "linear-gradient(90deg, #FF00F2 0%, #822AFF 100%)",
    BUTTON_BORDER: "#FFFFFF",
    BUTTON_SHADOW: "0px 4px 22px 0px rgba(255, 255, 255, 0.7)",
    BUTTON_TEXT: "#822AFF",
    BUTTON_TEXT_ACTIVE: "#FFFFFF",
    BUTTON_RADIUS: "100px",

    /* Figma 18055:23256 — footer strip (transparent over page bg) */
    FOOTER_TEXT: "#003",
    FOOTER_BORDER: "rgba(255,255,255,0.32)",
    FOOTER_BACKGROUND: "transparent",
    FOOTER_GRADIENT: "transparent",

    ERROR_TEXT_COLOR_1: "#FF0000",
    SUCCESS_TEXT_COLOR_1: "#00FF00",

    LOGIN_CARD_BACKGROUND_1: "rgba(255, 255, 255, 0.45)",

    TEXT_INPUT_BACKGROUND_1: "rgba(255, 255, 255, 0.55)",
    TEXT_INPUT_PLACEHOLDER_COLOR_1: "rgba(0, 0, 51, 0.45)",

    TEXT_INPUT_INNER_SHADOW_1: "rgba(255,255,255,0.35)",
    TEXT_INPUT_DROP_SHADOW_1: "rgba(255,255,255,0.55)",

    ACTION_BUTTON_BACKGROUND_1: "#E3CEFF",
    ACTION_BUTTON_BACKGROUND_2: "#FFFFFF",
    ACTION_BUTTON_BACKGROUND_3: "rgba(255, 255, 255, 0.45)",

    ACTION_BUTTON_BORDER_COLOR_1: "#FFFFFF",

    ACTION_BUTTON_TEXT_1: "#822AFF",
    ACTION_BUTTON_TEXT_2: "#822AFF",
    ACTION_BUTTON_TEXT_3: "#003",
    ACTION_BUTTON_DISABLED_BACKGROUND_1: "rgba(227, 206, 255, 0.45)",
    ACTION_BUTTON_DISABLED_TEXT_1: "rgba(130, 42, 255, 0.45)",
    ACTION_BUTTON_DISABLED_TEXT_2: "rgba(0, 0, 51, 0.4)",

    HEADER_PILL_BORDER: "#FFFFFF",
    HEADER_PILL_BACKGROUND: "linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.5) 100%)",
    HEADER_PILL_SHADOW: "0px 4px 22px 0px rgba(255, 255, 255, 0.7)",
    HEADER_NAV_ACTIVE: "#FF00F2",
    HEADER_NAV_INACTIVE: "#003",
    HEADER_AVATAR_BACKGROUND: "#FFCECA",
    HEADER_AVATAR_BORDER: "#FFFFFF",

    GAME_SELECTION_RAP_HOUSIE_CARD_GRADIENT_COLOR_1: "#0290E8",
    GAME_SELECTION_RAP_HOUSIE_CARD_GRADIENT_COLOR_2: "#0054E5",
    GAME_SELECTION_RAP_LEAGUE_CARD_GRADIENT_COLOR_1: "#05B7D2",
    GAME_SELECTION_RAP_LEAGUE_CARD_GRADIENT_COLOR_2: "#918C00",
    GAME_SELECTION_RAP_FIRE_CARD_GRADIENT_COLOR_1: "#FF8913",
    GAME_SELECTION_RAP_FIRE_CARD_GRADIENT_COLOR_2: "#EB6767",
    GAME_SELECTION_RAP_WHEEL_CARD_GRADIENT_COLOR_1: "#E751A8",
    GAME_SELECTION_RAP_WHEEL_CARD_GRADIENT_COLOR_2: "#E9005D",

    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_1_COLOR_1: "#FFD700",
    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_1_COLOR_2: "#FFD700",
    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_2_COLOR_1: "#FF071F",
    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_2_COLOR_2: "#FF071F",
    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_3_COLOR_1: "#E100FF",
    RAP_HOUSIE_ROOM_TYPE_HEADER_TEXT_GRADIENT_3_COLOR_2: "#E100FF",

    RAP_HOUSIE_ROOM_CODE_TEXT_GRADIENT_1_COLOR_1: "#5FE72E",
    RAP_HOUSIE_ROOM_CODE_TEXT_GRADIENT_1_COLOR_2: "#358119",

    RAP_HOUSIE_ROOM_JOINED_TEXT_COLOR_1: "#5FE72EB2",
    RAP_HOUSIE_ROOM_JOINED_TEXT_COLOR_2: "#FD6525E5",

    RAP_HOUSIE_TRIVIA_CARD_TEXT_COLOR_1: "#F4B400",
    RAP_HOUSIE_TRIVIA_CARD_TEXT_COLOR_2: "#FFFFFF",

    RAP_HOUSIE_CLAIM_BUTTON_BACKGROUND_1: "#1DA44F",
    RAP_HOUSIE_CLAIM_BUTTON_BACKGROUND_2: "#313131",
    RAP_HOUSIE_CLAIM_BUTTON_TEXT_COLOR_1: "#FBFBFB",

    RAP_HOUSIE_POPUP_VALIDATING_CLAIMS_TEXT_GRADIENT_COLOR_1: "#FFDE3F",
    RAP_HOUSIE_POPUP_VALIDATING_CLAIMS_TEXT_GRADIENT_COLOR_1: "#5FE72EB2",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_1_COLOR_1: "#350092",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_1_COLOR_2: "#9C63FF",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_1_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_1_BORDER_COLOR_2: "#752EEF",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_2_COLOR_1: "#DC077B",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_2_COLOR_2: "#FF60AD",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_2_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_2_BORDER_COLOR_2: "#FF5DAC",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_3_COLOR_1: "#3B5D00",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_3_COLOR_2: "#8CDC00",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_3_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_3_BORDER_COLOR_2: "#69A600",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_4_COLOR_1: "#BC0000",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_4_COLOR_2: "#FC5C02",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_4_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_4_BORDER_COLOR_2: "#F64B03",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_5_COLOR_1: "#00226E",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_5_COLOR_2: "#104CD2",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_5_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_5_BORDER_COLOR_2: "#0942C3",

    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_6_COLOR_1: "#917603",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_6_COLOR_2: "#FADD00",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_6_BORDER_COLOR_1: "#FFFFFF33",
    RAP_HOUSIE_LEADERBOARD_TEXT_GRADIENT_6_BORDER_COLOR_2: "#C7A500",

    RAP_HOUSIE_GRADIENTS: [
        {
            bg: ["#350092", "#9C63FF"],
            border: ["#FFFFFF33", "#752EEF"],
        },
        {
            bg: ["#DC077B", "#FF60AD"],
            border: ["#FFFFFF33", "#FF5DAC"],
        },
        {
            bg: ["#3B5D00", "#8CDC00"],
            border: ["#FFFFFF33", "#69A600"],
        },
        {
            bg: ["#BC0000", "#FC5C02"],
            border: ["#FFFFFF33", "#F64B03"],
        },
        {
            bg: ["#00226E", "#104CD2"],
            border: ["#FFFFFF33", "#0942C3"],
        },
        {
            bg: ["#917603", "#FADD00"],
            border: ["#FFFFFF33", "#C7A500"],
        },
    ],

};